import "./footer.css";

import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram, faLinkedinIn, faWhatsapp, faXTwitter, faThreads, faTiktok } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";

import NameLogoBranca from "../../../assets/logo/logo_vetor_branca.svg";
import { Links } from "../../../constants/_imports";

function Footer() {
    const location = useLocation();

    // Define se deve mostrar os termos de candidato ou empresa com base na rota atual
    // Considera '/candidato' e '/criarcurriculo' como contexto de candidato
    const isCandidateContext = location.pathname.startsWith('/candidato') || location.pathname.startsWith('/criarcurriculo');
    const termsLink = isCandidateContext ? "/termos-e-politica-candidatos" : "/termos-e-politica-empresa";

    return <footer className="Footer">
        <section className="FooterSection">
            <div className="LogoDesc">
                <img src={NameLogoBranca} alt="Logo Tonalida Branca" width="1275" height="341" />
                <p>A Tonalida é um sistema completo de R&S (Recrutamento e Seleção) que otimiza a gestão de vagas, divulgação e análise de candidatos. Conectamos empresas e talentos com eficiência, transformando o RH com tecnologia e inteligência de dados.</p>
                <div>
                    <a href={Links.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                        <FontAwesomeIcon className="IconFooter" icon={faInstagram} />
                    </a>
                    <a href={Links.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                        <FontAwesomeIcon className="IconFooter" icon={faFacebook} />
                    </a>
                    <a href={Links.x} target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
                        <FontAwesomeIcon className="IconFooter" icon={faXTwitter} />
                    </a>
                    <a href={Links.threds} target="_blank" rel="noopener noreferrer" aria-label="Threads">
                        <FontAwesomeIcon className="IconFooter" icon={faThreads} />
                    </a>
                    <a href={Links.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                        <FontAwesomeIcon className="IconFooter" icon={faTiktok} />
                    </a>
                    {/* <a href={Links.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                        <FontAwesomeIcon className="IconFooter" icon={faYoutube} />
                    </a> */}
                    <a href={Links.linkding} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                        <FontAwesomeIcon className="IconFooter" icon={faLinkedinIn} />
                    </a>
                </div>
            </div>
            <div className="Directs">
                <div className="Links">
                    <h3>Links úteis</h3>
                    <Link to={Links.portal}>Portal empresas</Link>
                    <Link to={Links.appEntPlay}>TONALIDA empresas</Link>
                    <Link to={Links.appCandPlay}>TONALIDA vagas Android</Link>
                    <Link to={Links.appCandIos}>TONALIDA vagas IOS</Link>
                    <Link to="/criarcurriculo">Criar currículo</Link>
                </div>
                <div className="Contacts">
                    <h3>Contatos</h3>
                    <div>
                        <FontAwesomeIcon icon={faWhatsapp} />
                        <p>(46) 99123 - 2216</p>
                    </div>
                    <div>
                        <FontAwesomeIcon icon={faEnvelope} />
                        <p>comercial@tonalida.com.br</p>
                    </div>
                    <div>
                        <FontAwesomeIcon icon={faWhatsapp} />
                        <p>(46) 92001 - 5850</p>
                    </div>
                    <div>
                        <FontAwesomeIcon icon={faEnvelope} />
                        <p>contato@tonalida.com.br</p>
                    </div>
                </div>
            </div>
        </section>
        <div className="FooterDivider"></div>
        <section className="FooterBottom">
            <p>@2025 direitos reservados a empresa Tonalida Soluções em Tecnologia</p>
            <Link to={termsLink} className="TermsLink">Termos e Politicas de Uso</Link>
        </section>
    </footer>
}

export default Footer;